import { render, staticRenderFns } from "./AirStrategy.vue?vue&type=template&id=00f7023c&scoped=true"
import script from "./AirStrategy.vue?vue&type=script&lang=js"
export * from "./AirStrategy.vue?vue&type=script&lang=js"
import style0 from "./AirStrategy.vue?vue&type=style&index=0&id=00f7023c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f7023c",
  null
  
)

export default component.exports